function readAccents(): { accent: string; ink: string } {
  const styles = getComputedStyle(document.documentElement);
  const accent = styles.getPropertyValue('--accent').trim() || '#c8f25c';
  const ink = styles.getPropertyValue('--accent-ink').trim() || '#0a0b0d';
  return { accent, ink };
}

function buildSvg(accent: string, ink: string): string {
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">` +
    `<rect width="32" height="32" rx="7" fill="${accent}"/>` +
    `<ellipse cx="8.5" cy="11" rx="1.7" ry="2.1" fill="${ink}" transform="rotate(-15 8.5 11)"/>` +
    `<ellipse cx="23.5" cy="11" rx="1.7" ry="2.1" fill="${ink}" transform="rotate(15 23.5 11)"/>` +
    `<path d="M16 7C22 7 26 11 26 17C26 23 22 27 16 27C10 27 6 23 6 17C6 11 10 7 16 7Z" fill="${ink}"/>` +
    `<circle cx="11.8" cy="21.5" r="3.6" fill="${accent}"/>` +
    `<circle cx="20.2" cy="21.5" r="3.6" fill="${accent}"/>` +
    `<path d="M14.2 17.2Q16 16 17.8 17.2Q17.8 19 16 20.2Q14.2 19 14.2 17.2Z" fill="${ink}"/>` +
    `<circle cx="11.5" cy="14" r="1.35" fill="${accent}"/>` +
    `<circle cx="20.5" cy="14" r="1.35" fill="${accent}"/>` +
    `<circle cx="11.9" cy="13.6" r="0.42" fill="${ink}"/>` +
    `<circle cx="20.9" cy="13.6" r="0.42" fill="${ink}"/>` +
    `<path d="M14.5 22Q16 23.4 17.5 22" stroke="${ink}" stroke-width="1" fill="none" stroke-linecap="round"/>` +
    `<line x1="5" y1="20" x2="8.5" y2="20.5" stroke="${ink}" stroke-width="0.6" stroke-linecap="round" opacity="0.8"/>` +
    `<line x1="5" y1="22.5" x2="8.5" y2="22" stroke="${ink}" stroke-width="0.6" stroke-linecap="round" opacity="0.8"/>` +
    `<line x1="27" y1="20" x2="23.5" y2="20.5" stroke="${ink}" stroke-width="0.6" stroke-linecap="round" opacity="0.8"/>` +
    `<line x1="27" y1="22.5" x2="23.5" y2="22" stroke="${ink}" stroke-width="0.6" stroke-linecap="round" opacity="0.8"/>` +
    `</svg>`
  );
}

function ensureLink(): HTMLLinkElement {
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/svg+xml';
    document.head.appendChild(link);
  }
  return link;
}

function ensureMeta(): HTMLMetaElement {
  let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }
  return meta;
}

function update(): void {
  const { accent, ink } = readAccents();
  const svg = buildSvg(accent, ink);
  ensureLink().href = `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  ensureMeta().content = accent;
}

export function initFavicon(): void {
  update();
  const observer = new MutationObserver(() => update());
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
}
